export function getMoveActionVerb(activeStageIndex: number, newStageIndex?: number | null): string {
    if (newStageIndex == null) {
        return '';
    }

    if (activeStageIndex < newStageIndex) {
        return 'advance';
    }

    return 'move';
}
